import { Row, Col, Stack, Badge, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AlertMessage from "../../../components/AlertMessage";
import FormClaim from "../components/new/FormClaim";
import LoadDocument from "../components/new/LoadDocument";
import ProcessDocument from "../components/new/ProcessDocument";
import { AppDispatch } from "../../../redux/store";
import { resetClaimForm } from "../../../redux/claimFormSlice";

export default function NewClaim() {
    const { t } = useTranslation('claim');

    const dispatch = useDispatch<AppDispatch>();
    const [initialFile, setInitialFile] = useState<File | null>(null);
    const [isStepLoadDocument, setIsStepLoadDocument] = useState<boolean>(false);
    const [isStepReadDocument, setIsStepReadDocument] = useState<boolean>(false);
    const [isStepValidateFormData, setIsStepValidateFormData] = useState<boolean>(false);
    const [isStepProcessDocument, setIsStepProcessDocument] = useState<boolean>(false);
    const [isStepSaveResult, setIsStepSaveResult] = useState<boolean>(false);
    const [messageError, setMessageError] = useState<string | null>(null);
    const [isLoadFormWithoutDocument, setIsLoadFormWithoutDocument] = useState<boolean>(false);

    useEffect(() => {
        dispatch(resetClaimForm());
        return () => {
            dispatch(resetClaimForm());
        };
    }, [dispatch]);

    return (
        <>
            <Row>
               <h2> {t("claim:newClaimTitle")}</h2>
            </Row>
            <Row className="steps">
                {!isLoadFormWithoutDocument && (
                    <>
                        <Col xs={2} md={2}>
                            <Stack direction="horizontal" gap={2} className="align-items-start">
                                <Badge
                                    pill
                                    className="d-flex justify-content-center align-items-center badge-primary-circle"
                                >
                                </Badge>
                                <Badge
                                    bg="primary"
                                    pill
                                    className={`text-wrap text-start align-self-center ${isStepLoadDocument ? 'badge-primary' : 'badge-secondary'}`} >
                                    {t("claim:newClaimStepLoadDocument")}
                                </Badge>
                            </Stack>
                        </Col>
                
                        <Col xs={2} md={2}>
                            <Stack direction="horizontal" gap={2} className="align-items-start">
                                <Badge
                                    bg="primary"
                                    pill
                                    className={`d-flex justify-content-center align-items-center badge-secondary-circle ${isStepLoadDocument ? 'badge-primary-circle' : 'badge-secondary-circle'}`} >
                        
                                </Badge>
                                <Badge
                                    bg="primary"
                                    pill
                                    className={`text-wrap text-start align-self-center ${isStepReadDocument ? 'badge-primary' : 'badge-secondary'}`} >
                        
                                    {t("claim:newClaimStepReadDocument")}
                                </Badge>
                            </Stack>
                        </Col>
                    </>
                )}
                <Col xs={2} md={2}>
                    <Stack direction="horizontal" gap={2} className="align-items-start">
                        <Badge
                            bg="primary"
                            pill
                            className={`d-flex justify-content-center align-items-center badge-secondary-circle ${isStepReadDocument ? 'badge-primary-circle' : 'badge-secondary-circle'}`} 
                        >
                        </Badge>
                        <Badge
                            bg="primary"
                            pill
                            className={`text-wrap text-start align-self-center ${isStepValidateFormData ? 'badge-primary' : 'badge-secondary'}`} 
                        >
                            {isLoadFormWithoutDocument ? t("claim:newClaimStepAddData") : t("claim:newClaimStepValidateData")}
                        </Badge>
                    </Stack>
                </Col>
                <Col xs={2} md={2}>
                    <Stack direction="horizontal" gap={2} className="align-items-start">
                        <Badge
                            bg="primary"
                            pill
                            className={`d-flex justify-content-center align-items-center badge-secondary-circle ${isStepValidateFormData ? 'badge-primary-circle' : 'badge-secondary-circle'}`} 
                        >
                        </Badge>
                        <Badge
                            bg="primary"
                            pill
                            className={`text-wrap text-start align-self-center ${isStepProcessDocument ? 'badge-primary' : 'badge-secondary'}`} 
                        >
                            {t("claim:newClaimStepProcessDemand")}
                        </Badge>
                    </Stack>
                </Col>
                <Col xs={2} md={2}>
                    <Stack direction="horizontal" gap={2} className="align-items-start">
                        <Badge
                            bg="primary"
                            pill
                            className={`d-flex justify-content-center align-items-center badge-secondary-circle ${isStepProcessDocument ? 'badge-primary-circle' : 'badge-secondary-circle'}`} 
                        >
                        </Badge>
                        <Badge
                            bg="primary"
                            pill
                            className="text-wrap text-start align-self-center badge-secondary"
                        >
                            {t("claim:newClaimStepSaveResult")}
                        </Badge>
                    </Stack>
                </Col>
            </Row>

            {messageError && (
                <Row className="mt-4">
                    <AlertMessage message={messageError} type={"danger"}
                            displayTime={5000} />
                </Row>
            )}
            <Row className="gx-4">
                <Col xs={6} md={6} className="mt-4">
                    <Container className="content-midle-layout">
                        {!isStepValidateFormData && (
                            <LoadDocument 
                                setInitialFile={setInitialFile}
                                setIsStepLoadDocument={setIsStepLoadDocument}
                                setIsStepReadDocument={setIsStepReadDocument}
                                setIsLoadFormWithoutDocument={setIsLoadFormWithoutDocument}
                            />
                        )}
                        {isStepValidateFormData && (
                            <FormClaim
                                initialFile={initialFile}
                                setIsStepReadDocument={setIsStepReadDocument}
                                setIsStepValidateFormData={setIsStepValidateFormData}
                                isStepReadDocument={isStepReadDocument}
                                isStepValidateFormData={isStepValidateFormData}
                                setMessageError={setMessageError} 
                                readOnly={true}
                            />
                        )}                       
                    </Container>
                </Col>
                <Col xs={6} md={6} className="mt-4">
                    <Container className="content-midle-layout">
                        {isStepLoadDocument && !isStepValidateFormData && (
                            <FormClaim
                                initialFile={initialFile}
                                setIsStepReadDocument={setIsStepReadDocument}
                                setIsStepValidateFormData={setIsStepValidateFormData}
                                isStepReadDocument={isStepReadDocument}
                                isStepValidateFormData={isStepValidateFormData}
                                setMessageError={setMessageError}
                                readOnly={false}
                            />
                        )}
                        {isStepValidateFormData && (
                            <ProcessDocument
                                setIsStepProcessDocument={setIsStepProcessDocument}
                                setIsStepSaveResult={setIsStepSaveResult}
                                isStepProcessDocument={isStepProcessDocument}
                                isStepSaveResult={isStepSaveResult}
                                setMessageError={setMessageError} 
                            />
                        )}
                    </Container>
                </Col>
            </Row>
        </>        
    );
}
